import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {useNavigate} from "react-router-dom";
import api from "../services/api";
import helmet from '../assets/helmet.png'

export default function NewPlayer() {
    const navigate = useNavigate()

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        api().newPlayer({
            name: data.get('name'),
        })
            .then(() => navigate('/players'))
            .catch(error => console.log(error))
    };

    return (
        <>
            <img src={helmet} alt={'closed chest'} width={60}/>
            <Typography component="h1" variant="h5">
                Bienvenue !
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="name"
                    label="Nom du joueur"
                    name="name"
                    autoComplete="name"
                    autoFocus
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Créer
                </Button>
            </Box>
        </>
    );
}
